import screenfull from "screenfull";
import Application from "./Application";
import common from "./common";
import PreloaderScene from "./scenes/PreloaderScene";
import {isEdge18, isFacebookApp, isFossil, isIE11, isIE11Win10, isWebView} from "./utils";

import getParameter from "get-parameter";
import moment from "moment";

export default class Main {
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
        this._startReady = false;
    }

    init() {
        P3.assets.audioFileTypes = ["ogg", "mp3"];

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;

        P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 = false;
        P3.settings.WARN_TEXTURE_MISSING = true;

        //P3.audio.forceHTML5Audio = isFossil() || isEdge18() || isIE11();
        P3.audio.forceHTML5Audio = isEdge18() || isIE11();
        P3.audio.preloadAudio = true;

        common.gmi = window.gmi;
        const settings = common.gmi.getAllSettings();
        P3.audio.mute(!settings.audio);
        P3.audio.mute(typeof settings.gameData !== "undefined" ? !settings.gameData.button_audio : false, "button");
        console.log(common.gmi.getAllSettings());

        typeof TweenMax !== "undefined" && (TweenMax.defaultOverwrite = "none");

        if (PIXI.utils.isMobile.android.device && screenfull.enabled) {
            screenfull.on("change", () => {
                setTimeout(() => {
                    common.view.resize();
                }, 1000);
            });
        }

        const rotateImageUrl = isFacebookApp() ? "assets/images/ui_social_media_message.jpg" : "assets/images/rotate_device.jpg";

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game-holder",
            portrait: false,
            rotateImageUrl: (common.gmi ? common.gmi.gameDir : "./") + rotateImageUrl,
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function(canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = PIXI.utils.isMobile.android.device || PIXI.utils.isMobile.amazon.device;
            options.antialias = false;
            options.preserveDrawingBuffer = options.transparent;
            options.resolution = 1;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            if (P3.utils.isCocoonJS()) {
                stage.scale.x = window.innerHeight / this._height;
                stage.scale.y = window.innerHeight / this._height;
            }

            const renderer = !P3.utils.isCocoonJS() ?
                PIXI.autoDetectRenderer(this._width, this._height, options) :
                new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            common.renderer = renderer;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            window.lasttweentime = 0;
            window.tweendt = 0;

            PIXI.ticker.shared.add((deltaTime) => {
                if (view.isCorrectOrientation)
                {
                    window.dt = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                    P3.scene.update();
                    P3.input.update();

                    const currentTime = P3.utils.TWEEN.now();
                    window.tweendt = currentTime - window.lasttweentime;
                    window.lasttweentime = currentTime;

                    P3.utils.TWEEN.update();     // comment this line out if you are using TweenMax

                    renderer.render(stage);
                }
            });

            if (isFacebookApp()) {
                const blocker = new PIXI.Sprite(PIXI.Texture.fromImage((common.gmi ? common.gmi.gameDir : "./") + rotateImageUrl));
                blocker.position.set(P3.View.width * 0.5, P3.View.height * 0.5);
                blocker.rotation = -Math.PI * 0.5;
                blocker.anchor.set(0.5, 0.5);
                blocker.visible = false;
                common.stage.addChild(blocker);

                blocker.texture.on("update", () => {
                    const aspectRatio = blocker.texture.height / blocker.texture.width;

                    blocker.width = P3.View.height;
                    blocker.height = blocker.width * aspectRatio;
                    blocker.visible = true;
                });
            } else {
                this.loadPreAssets();
            }
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function() {view.init()}, this);    // we load the config before we do anything

        this.applyViewPatch();

        $(window)
            .focus(() => { Howler.volume(1) })
            .blur(() => { Howler.volume(0) });
    }

    loadConfig(callback, scope) {
        scope = scope || window;

        common.days = moment().diff("2020-01-01", "days");
        common.date = moment().format("DD/MM/YY");
        common.weekday = moment().weekday();
        common.week = moment().week();
        common.year = moment().year();

        const basePath = common.gmi ? common.gmi.gameDir : "./";
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], basePath);
        P3.assets.signals.complete.once(function() {
            common.config = P3.assets.json("config");

            /*
            const questionCount = getParameter("questionCount");
            if (questionCount !== "")
            {
                common.config.game.question_count = Number.parseInt(questionCount);
            }

            const forceBoss = getParameter("forceBoss");
            if (forceBoss !== "")
            {
                common.config.game.debug_boss = forceBoss;
            }

            const week = getParameter("forceWeek");
            if (week !== "")
            {
                common.week = Number.parseInt(week);
            }

            const xp = getParameter("extraXP");
            if (xp !== "")
            {
                common.extraXP = true;
            }

            const level = getParameter("forceLevel")
            if (level !== "")
            {
                common.config.game.debug_level = Number.parseInt(level);
            }
            */

            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        let files = [
            {name: "static_questions", url: "data/static_questions" + ".json"},
            {name: "skin_slot_data", url: "data/skin_slot_data" + ".json"},
            {name: "bosses", url: "data/bosses" + ".json"},
            {name: "characters", url: "data/characters" + ".json"},
            {name: "equipment", url: "data/equipment" + ".json"},
            {name: "locations", url: "data/locations" + ".json"},
            {name: "questions", url: "data/questions" + ".json"},
            {name: "templates", url: "data/templates" + ".json"},
            {name: "subtitles", url: "data/subtitles" + ".json"},
            {name: "strings", url: "data/strings" + ".json"},
            {name: "achievements", url: "data/achievements" + ".json"},

            {name: "reith_44", url: "fonts/reith_44" + ".xml"},
            {name: "reith_100", url: "fonts/reith_100" + ".xml"},
            {name: "bbc_reith_mathssymbols_24pt", url: "fonts/bbc_reith_mathssymbols_24pt" + ".xml"},
            {name: "bbc_reith_mathssymbols_48pt", url: "fonts/bbc_reith_mathssymbols_48pt" + ".xml"},
            {name: "carter_one_32", url: "fonts/carter_one_32" + ".xml"}
        ];
        files = files.concat(PIXI.utils.isMobile.any ? [
            {name: "ui_9slice", url: "images/ui_9slice_0.6x" + ".json"},
            {name: "ui_preloader_1x", url: "images/ui_preloader_0.6x" + ".json"},
            {name: "ui_preloader", url: "images/ui_preloader_0.5x" + ".jpg"}
        ] : [
            {name: "ui_9slice", url: "images/ui_9slice_1x" + ".json"},
            {name: "ui_preloader_1x", url: "images/ui_preloader_1x" + ".json"},
            {name: "ui_preloader", url: "images/ui_preloader" + ".jpg"}
        ]);
        if (files.length) {
            const basePath = common.gmi ? common.gmi.gameDir : "./";
            P3.assets.addFiles(files, basePath + "assets/");
            P3.assets.signals.complete.once(this.loadMinimumAssets, this);
            P3.assets.load();
        } else this.loadMinimumAssets();
    }

    loadMinimumAssets()
    {
        let files =
        [
            // spine texture sheets
            {name: "guardians_spine_elf_all", url: "images/guardians_spine_elf_all_0.6x" + ".json"},
            {name: "guardians_spine_knight_all", url: "images/guardians_spine_knight_all_0.6x" + ".json"},
            {name: "guardians_spine_ranger_all", url: "images/guardians_spine_ranger_all_0.6x" + ".json"},
            {name: "guardians_spine_warrior_all", url: "images/guardians_spine_warrior_all_0.6x" + ".json"},
            {name: "guardians_spine_witch_all", url: "images/guardians_spine_witch_all_0.6x" + ".json"},
            {name: "guardians_spine_wizard_all", url: "images/guardians_spine_wizard_all_0.6x" + ".json"},
            {name: "guardians_spine_equip", url: "images/guardians_spine_equip_0.6x" + ".json"},
            {name: "guardians_spine_pets", url: "images/guardians_spine_pets_0.6x" + ".json"},
            {name: "guardians_spine_vfx", url: "images/guardians_spine_vfx_0.6x" + ".json"},

            // spine
            {name: "adversary_dragon", url: "spine/adversary_dragon" + ".json"},
            {name: "adversary_spider", url: "spine/adversary_spider" + ".json"},
            {name: "adversary_hobgoblin", url: "spine/adversary_hobgoblin" + ".json"},
            {name: "adversary_troll", url: "spine/adversary_troll" + ".json"},
            {name: "adversary_trainingtroll", url: "spine/adversary_trainingtroll" + ".json"},
            {name: "adversary_mage", url: "spine/adversary_mage" + ".json"},
            {name: "adversary_spirit", url: "spine/adversary_spirit" + ".json"},
            {name: "challenge_flag", url: "spine/challenge_flag" + ".json"},

            // particles
            {name: "particle_emitter_dragon_flame", url: "particles/particle_emitter_dragon_flame" + ".json"},
            {name: "particle_equip_character_0", url: "particles/particle_equip_character_0" + ".json"},
            {name: "particle_change_character_0", url: "particles/particle_change_character_0" + ".json"},
            {name: "particle_loot_coins_burst_0", url: "particles/particle_loot_coins_burst_0" + ".json"},
            {name: "particle_fairy_dust", url: "particles/particle_fairy_dust" + ".json"},
            {name: "particle_fire_fg_flame_00", url: "particles/particle_fire_fg_flame_00" + ".json"},
            {name: "particle_fire_bg_smoke_00", url: "particles/particle_fire_bg_smoke_00" + ".json"},
            {name: "particle_orb", url: "particles/particle_orb" + ".json"},
            {name: "particle_orb_big", url: "particles/particle_orb_big" + ".json"},
            {name: "particle_weapon_reveal_0", url: "particles/particle_weapon_reveal_0" + ".json"},
        ];

        files = files.concat(PIXI.utils.isMobile.any ?
            [
                {name: "ui_gel", url: "images/gel_btns_mobile_1x" + ".json"},

                {name: "ui_splash", url: "images/ui_splash_0.5x" + ".jpg"},
                {name: "ui_results_bg1", url: "images/ui_results_0.5x" + ".jpg"},

                {name: "ui_achievements", url: "images/ui_achievements_0.6x" + ".json"},
                {name: "ui_elements", url: "images/ui_elements_0.6x" + ".json"},
                {name: "ui_help", url: "images/ui_help_0.6x" + ".json"},
                {name: "ui_btns", url: "images/ui_btns_0.6x" + ".json"},

                {name: "fx", url: "images/fx_0.6x" + ".json"},
                {name: "ui_particle_fx", url: "images/ui_particle_fx_0.5x" + ".json"}
            ]
            :
            [
                {name: "ui_gel", url: "images/gel_btns_desktop_1x" + ".json"},

                {name: "ui_splash", url: "images/ui_splash" + ".jpg"},
                {name: "ui_results_bg1", url: "images/ui_results" + ".jpg"},

                {name: "ui_achievements", url: "images/ui_achievements_1x" + ".json"},
                {name: "ui_elements", url: "images/ui_elements_1x" + ".json"},
                {name: "ui_help", url: "images/ui_help_1x" + ".json"},
                {name: "ui_btns", url: "images/ui_btns_1x" + ".json"},

                {name: "fx", url: "images/fx_1x" + ".json"},
                {name: "ui_particle_fx", url: "images/ui_particle_fx_1x" + ".json"}
            ]
        );

        if (isIE11() || isIE11Win10())
        {
            files = files.concat(
                [
                    //music
                    {name: "music_mathematica_main_theme", url: "audio/mono/music/music_mathematica_main_theme" + P3.assets.audioFileExt},

                    //vo
                    {name: "vo_queen_163", url: "audio/mono/vos/queen/vo_queen_163" + P3.assets.audioFileExt}
                ]
            );
        }
        else
        {
            files = files.concat(
                [
                    //music
                    {name: "music_mathematica_main_theme", url: "audio/mono/music/music_mathematica_main_theme" + P3.assets.audioFileExt},

                    //sfx
                    {name: "sfx_btn_press_00", url: "audio/mono/sfx_btn_press_00" + P3.assets.audioFileExt},
                    {name: "sfx_btn_rollover_00", url: "audio/mono/sfx_btn_rollover_00" + P3.assets.audioFileExt},

                    //vo
                    {name: "vo_queen_03", url: "audio/mono/vos/queen/vo_queen_03" + P3.assets.audioFileExt},
                    {name: "vo_queen_103a", url: "audio/mono/vos/queen/vo_queen_103a" + P3.assets.audioFileExt},
                    {name: "vo_queen_105b", url: "audio/mono/vos/queen/vo_queen_105b" + P3.assets.audioFileExt},
                    {name: "vo_queen_106b", url: "audio/mono/vos/queen/vo_queen_106b" + P3.assets.audioFileExt},
                    {name: "vo_queen_107", url: "audio/mono/vos/queen/vo_queen_107" + P3.assets.audioFileExt},
                    {name: "vo_queen_163", url: "audio/mono/vos/queen/vo_queen_163" + P3.assets.audioFileExt}
                ]
            );
        }

        if (files.length)
        {
            common.config.strings = P3.assets.json("strings");

            this._preloader = new PreloaderScene();
            this._preloader.signals.next.add(() =>
            {
                if (this._startReady)
                {
                    this.start();
                }

                this._startReady = true;
            });
            P3.scene.show(this._preloader);

            const basePath = common.gmi ? common.gmi.gameDir : "./";
            P3.assets.addFiles(files, basePath + "assets/");
            P3.assets.signals.complete.once(() => this.loadSharedSpines());

            P3.assets.load();
        }
        else
        {
            this.start();
        }
    }

    loadRequiredAssets()
    {
        let files =
            [
                {name: "wooden_table_texture", url: "images/wooden_table_texture" + ".jpg"},

                {name: "character_island_0", url: "images/environments/character_island_0" + ".png"},
                {name: "env_bg_char_select", url: "images/environments/env_bg_char_select_0.5x" + ".jpg"}
            ];

        files = files.concat(PIXI.utils.isMobile.any ? [
            {name: "ui_levelselect", url: "images/ui_levelselect_0.6x" + ".json"},
            {name: "ui_equip", url: "images/ui_equip_0.6x" + ".json"},
            {name: "ui_results", url: "images/ui_results_0.6x" + ".json"},
            {name: "shapes", url: "images/shapes_0.6x" + ".json"},
            {name: "measurement", url: "images/measurement_0.6x" + ".json"},

            {name: "map_2048", url: "images/map_2048_0.5x" + ".jpg"}
        ] : [
            {name: "ui_levelselect", url: "images/ui_levelselect_1x" + ".json"},
            {name: "ui_equip", url: "images/ui_equip_1x" + ".json"},
            {name: "ui_results", url: "images/ui_results_1x" + ".json"},

            {name: "shapes", url: "images/shapes_1x" + ".json"},
            {name: "measurement", url: "images/measurement_1x" + ".json"},

            {name: "map_2048", url: "images/map_2048_1x" + ".jpg"}
        ]);

        if (isIE11() || isIE11Win10())
        {
            files = files.concat([
                // vos
                {name: "vo_queen_57", url: "audio/mono/vos/queen/vo_queen_57" + P3.assets.audioFileExt},
                {name: "vo_queen_58", url: "audio/mono/vos/queen/vo_queen_58" + P3.assets.audioFileExt},
                {name: "vo_queen_61b", url: "audio/mono/vos/queen/vo_queen_61b" + P3.assets.audioFileExt},
                {name: "vo_queen_126", url: "audio/mono/vos/queen/vo_queen_126" + P3.assets.audioFileExt},
                {name: "vo_queen_127b", url: "audio/mono/vos/queen/vo_queen_127b" + P3.assets.audioFileExt},
                {name: "vo_queen_128", url: "audio/mono/vos/queen/vo_queen_128" + P3.assets.audioFileExt},

                {name: "vo_queen_62a", url: "audio/mono/vos/queen/vo_queen_62a" + P3.assets.audioFileExt},
                {name: "vo_queen_64", url: "audio/mono/vos/queen/vo_queen_64" + P3.assets.audioFileExt},
                {name: "vo_queen_68", url: "audio/mono/vos/queen/vo_queen_68" + P3.assets.audioFileExt},
                {name: "vo_queen_69", url: "audio/mono/vos/queen/vo_queen_69" + P3.assets.audioFileExt},
                {name: "vo_queen_70a", url: "audio/mono/vos/queen/vo_queen_70a" + P3.assets.audioFileExt},
                {name: "vo_queen_71a", url: "audio/mono/vos/queen/vo_queen_71a" + P3.assets.audioFileExt},
                {name: "vo_queen_72a", url: "audio/mono/vos/queen/vo_queen_72a" + P3.assets.audioFileExt},

                // music
                {name: "music_avatar_loop_00", url: "audio/mono/music/music_avatar_loop_00" + P3.assets.audioFileExt},
                {name: "music_battle_loop_01", url: "audio/mono/music/music_battle_loop_01" + P3.assets.audioFileExt},
                {name: "music_battle_loop_02", url: "audio/mono/music/music_battle_loop_02" + P3.assets.audioFileExt},
                {name: "music_battle_loop_03", url: "audio/mono/music/music_battle_loop_03" + P3.assets.audioFileExt},
                {name: "music_timed_battle_01", url: "audio/mono/music/music_timed_battle_01" + P3.assets.audioFileExt},
                {name: "music_timed_battle_02", url: "audio/mono/music/music_timed_battle_02" + P3.assets.audioFileExt},
                {name: "music_timed_battle_03", url: "audio/mono/music/music_timed_battle_03" + P3.assets.audioFileExt},
                {name: "music_pause_menu", url: "audio/mono/music/music_pause_menu" + P3.assets.audioFileExt},
                {name: "music_results_loop", url: "audio/mono/music/music_results_loop" + P3.assets.audioFileExt}
            ]);
        }
        else
        {
            files = files.concat(isFossil() ? [
                // vos
                {name: "vo_queen_57", url: "audio/mono/vos/queen/vo_queen_57" + P3.assets.audioFileExt},
                {name: "vo_queen_58", url: "audio/mono/vos/queen/vo_queen_58" + P3.assets.audioFileExt},
                {name: "vo_queen_61b", url: "audio/mono/vos/queen/vo_queen_61b" + P3.assets.audioFileExt},
                {name: "vo_queen_126", url: "audio/mono/vos/queen/vo_queen_126" + P3.assets.audioFileExt},
                {name: "vo_queen_127b", url: "audio/mono/vos/queen/vo_queen_127b" + P3.assets.audioFileExt},
                {name: "vo_queen_128", url: "audio/mono/vos/queen/vo_queen_128" + P3.assets.audioFileExt},

                // music
                {name: "music_avatar_loop_00", url: "audio/mono/music/music_avatar_loop_00" + P3.assets.audioFileExt},
                {name: "music_battle_loop_01", url: "audio/mono/music/music_battle_loop_01" + P3.assets.audioFileExt},
                {name: "music_battle_loop_02", url: "audio/mono/music/music_battle_loop_02" + P3.assets.audioFileExt},
                {name: "music_battle_loop_03", url: "audio/mono/music/music_battle_loop_03" + P3.assets.audioFileExt},
                {name: "music_timed_battle_01", url: "audio/mono/music/music_timed_battle_01" + P3.assets.audioFileExt},
                {name: "music_timed_battle_02", url: "audio/mono/music/music_timed_battle_02" + P3.assets.audioFileExt},
                {name: "music_timed_battle_03", url: "audio/mono/music/music_timed_battle_03" + P3.assets.audioFileExt},
                {name: "music_pause_menu", url: "audio/mono/music/music_pause_menu" + P3.assets.audioFileExt},
                {name: "music_results_loop", url: "audio/mono/music/music_results_loop" + P3.assets.audioFileExt},

                // sfx
                {name: "sfx_scroll_disappear_00", url: "audio/mono/sfx_scroll_disappear_00" + P3.assets.audioFileExt},
                {name: "sfx_scroll_open_00", url: "audio/mono/sfx_scroll_open_00" + P3.assets.audioFileExt},
                {name: "sfx_scroll_open_01", url: "audio/mono/sfx_scroll_open_01" + P3.assets.audioFileExt},
                {name: "sfx_round_lost_00", url: "audio/mono/sfx_round_lost_00" + P3.assets.audioFileExt},
                {name: "sfx_round_won_00", url: "audio/mono/sfx_round_won_00" + P3.assets.audioFileExt},
                {name: "sfx_level_select_card_00", url: "audio/mono/sfx_level_select_card_00" + P3.assets.audioFileExt},
                {name: "sfx_loot_crate_reveal_02", url: "audio/mono/sfx_loot_crate_reveal_02" + P3.assets.audioFileExt},
                {name: "sfx_loot_crate_reveal_03", url: "audio/mono/sfx_loot_crate_reveal_03" + P3.assets.audioFileExt},
                {name: "sfx_lootcrate_open_00", url: "audio/mono/sfx_lootcrate_open_00" + P3.assets.audioFileExt},
                {name: "sfx_customise_close_00", url: "audio/mono/sfx_customise_close_00" + P3.assets.audioFileExt},
                {name: "sfx_customise_open_00", url: "audio/mono/sfx_customise_open_00" + P3.assets.audioFileExt},
                {name: "sfx_btn_keypad_press_00", url: "audio/mono/sfx_btn_keypad_press_00" + P3.assets.audioFileExt},
                {name: "sfx_btn_keypad_rollover_00", url: "audio/mono/sfx_btn_keypad_rollover_00" + P3.assets.audioFileExt},
                {name: "sfx_avatar_loop_ambience_01", url: "audio/mono/sfx_avatar_loop_ambience_01" + P3.assets.audioFileExt},
                {name: "sfx_block_move_00", url: "audio/mono/sfx_block_move_00" + P3.assets.audioFileExt},
                {name: "sfx_block_placed_01", url: "audio/mono/sfx_block_placed_01" + P3.assets.audioFileExt},

                {name: "sfx_guardian_arrow_attack_00", url: "audio/mono/sfx_guardian_arrow_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_hammer_attack_00", url: "audio/mono/sfx_guardian_hammer_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_magic_attack_00", url: "audio/mono/sfx_guardian_magic_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_spear_attack_00", url: "audio/mono/sfx_guardian_spear_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_spell_attack_00", url: "audio/mono/sfx_guardian_spell_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_sword_attack_00", url: "audio/mono/sfx_guardian_sword_attack_00" + P3.assets.audioFileExt},

                {name: "sfx_shield_level_1", url: "audio/mono/sfx_shield_level_1" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_2", url: "audio/mono/sfx_shield_level_2" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_3", url: "audio/mono/sfx_shield_level_3" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_4", url: "audio/mono/sfx_shield_level_4" + P3.assets.audioFileExt},

                {name: "sfx_enter_dragon", url: "audio/mono/sfx_enter_dragon" + P3.assets.audioFileExt},
                {name: "sfx_enter_hobgoblin", url: "audio/mono/sfx_enter_hobgoblin" + P3.assets.audioFileExt},
                {name: "sfx_enter_mage", url: "audio/mono/sfx_enter_mage" + P3.assets.audioFileExt},
                {name: "sfx_enter_spider", url: "audio/mono/sfx_enter_spider" + P3.assets.audioFileExt},
                {name: "sfx_enter_spirit", url: "audio/mono/sfx_enter_spirit" + P3.assets.audioFileExt},
                {name: "sfx_enter_troll", url: "audio/mono/sfx_enter_troll" + P3.assets.audioFileExt},

                {name: "sfx_generic_adversary_damage_00", url: "audio/mono/sfx_generic_adversary_damage_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_adversary_damage_01", url: "audio/mono/sfx_generic_adversary_damage_01" + P3.assets.audioFileExt},
                {name: "sfx_generic_adversary_damage_02", url: "audio/mono/sfx_generic_adversary_damage_02" + P3.assets.audioFileExt},

                {name: "sfx_generic_guardian_damage_female_00", url: "audio/mono/sfx_generic_guardian_damage_female_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_female_01", url: "audio/mono/sfx_generic_guardian_damage_female_01" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_female_02", url: "audio/mono/sfx_generic_guardian_damage_female_02" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_male_00", url: "audio/mono/sfx_generic_guardian_damage_male_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_male_01", url: "audio/mono/sfx_generic_guardian_damage_male_01" + P3.assets.audioFileExt},

                {name: "sfx_question_timer_01", url: "audio/mono/sfx_question_timer_01" + P3.assets.audioFileExt},
            ] : [
                // vos
                {name: "vo_queen_04b", url: "audio/mono/vos/queen/vo_queen_04b" + P3.assets.audioFileExt},
                {name: "vo_queen_07b", url: "audio/mono/vos/queen/vo_queen_07b" + P3.assets.audioFileExt},
                {name: "vo_queen_08", url: "audio/mono/vos/queen/vo_queen_08" + P3.assets.audioFileExt},
                {name: "vo_queen_10a", url: "audio/mono/vos/queen/vo_queen_10a" + P3.assets.audioFileExt},
                {name: "vo_queen_11b", url: "audio/mono/vos/queen/vo_queen_11b" + P3.assets.audioFileExt},
                {name: "vo_queen_13b", url: "audio/mono/vos/queen/vo_queen_13b" + P3.assets.audioFileExt},
                {name: "vo_queen_14b", url: "audio/mono/vos/queen/vo_queen_14b" + P3.assets.audioFileExt},
                {name: "vo_queen_16a", url: "audio/mono/vos/queen/vo_queen_16a" + P3.assets.audioFileExt},
                {name: "vo_queen_17", url: "audio/mono/vos/queen/vo_queen_17" + P3.assets.audioFileExt},
                {name: "vo_queen_19b", url: "audio/mono/vos/queen/vo_queen_19b" + P3.assets.audioFileExt},
                {name: "vo_queen_20b", url: "audio/mono/vos/queen/vo_queen_20b" + P3.assets.audioFileExt},
                {name: "vo_queen_21", url: "audio/mono/vos/queen/vo_queen_21" + P3.assets.audioFileExt},
                {name: "vo_queen_23", url: "audio/mono/vos/queen/vo_queen_23" + P3.assets.audioFileExt},
                {name: "vo_queen_25a", url: "audio/mono/vos/queen/vo_queen_25a" + P3.assets.audioFileExt},
                {name: "vo_queen_26a", url: "audio/mono/vos/queen/vo_queen_26a" + P3.assets.audioFileExt},
                {name: "vo_queen_27d", url: "audio/mono/vos/queen/vo_queen_27d" + P3.assets.audioFileExt},
                {name: "vo_queen_28a", url: "audio/mono/vos/queen/vo_queen_28a" + P3.assets.audioFileExt},
                {name: "vo_queen_29c", url: "audio/mono/vos/queen/vo_queen_29c" + P3.assets.audioFileExt},
                {name: "vo_queen_30c", url: "audio/mono/vos/queen/vo_queen_30c" + P3.assets.audioFileExt},
                {name: "vo_queen_31b", url: "audio/mono/vos/queen/vo_queen_31b" + P3.assets.audioFileExt},
                {name: "vo_queen_32a", url: "audio/mono/vos/queen/vo_queen_32a" + P3.assets.audioFileExt},
                {name: "vo_queen_33a", url: "audio/mono/vos/queen/vo_queen_33a" + P3.assets.audioFileExt},
                {name: "vo_queen_34", url: "audio/mono/vos/queen/vo_queen_34" + P3.assets.audioFileExt},
                {name: "vo_queen_35b", url: "audio/mono/vos/queen/vo_queen_35b" + P3.assets.audioFileExt},
                {name: "vo_queen_36a", url: "audio/mono/vos/queen/vo_queen_36a" + P3.assets.audioFileExt},
                {name: "vo_queen_37a", url: "audio/mono/vos/queen/vo_queen_37a" + P3.assets.audioFileExt},
                {name: "vo_queen_38a", url: "audio/mono/vos/queen/vo_queen_38a" + P3.assets.audioFileExt},
                {name: "vo_queen_39a", url: "audio/mono/vos/queen/vo_queen_39a" + P3.assets.audioFileExt},

                {name: "vo_queen_40c", url: "audio/mono/vos/queen/vo_queen_40c" + P3.assets.audioFileExt},
                {name: "vo_queen_41", url: "audio/mono/vos/queen/vo_queen_41" + P3.assets.audioFileExt},
                {name: "vo_queen_42b", url: "audio/mono/vos/queen/vo_queen_42b" + P3.assets.audioFileExt},
                {name: "vo_queen_43a", url: "audio/mono/vos/queen/vo_queen_43a" + P3.assets.audioFileExt},
                {name: "vo_queen_44a", url: "audio/mono/vos/queen/vo_queen_44a" + P3.assets.audioFileExt},
                {name: "vo_queen_45a", url: "audio/mono/vos/queen/vo_queen_45a" + P3.assets.audioFileExt},
                {name: "vo_queen_46", url: "audio/mono/vos/queen/vo_queen_46" + P3.assets.audioFileExt},
                {name: "vo_queen_47a", url: "audio/mono/vos/queen/vo_queen_47a" + P3.assets.audioFileExt},
                {name: "vo_queen_48", url: "audio/mono/vos/queen/vo_queen_48" + P3.assets.audioFileExt},
                {name: "vo_queen_49a", url: "audio/mono/vos/queen/vo_queen_49a" + P3.assets.audioFileExt},
                {name: "vo_queen_50", url: "audio/mono/vos/queen/vo_queen_50" + P3.assets.audioFileExt},
                {name: "vo_queen_51a", url: "audio/mono/vos/queen/vo_queen_51a" + P3.assets.audioFileExt},
                {name: "vo_queen_52", url: "audio/mono/vos/queen/vo_queen_52" + P3.assets.audioFileExt},
                {name: "vo_queen_53c", url: "audio/mono/vos/queen/vo_queen_53c" + P3.assets.audioFileExt},
                {name: "vo_queen_54a", url: "audio/mono/vos/queen/vo_queen_54a" + P3.assets.audioFileExt},

                {name: "vo_queen_56", url: "audio/mono/vos/queen/vo_queen_56" + P3.assets.audioFileExt},
                {name: "vo_queen_57", url: "audio/mono/vos/queen/vo_queen_57" + P3.assets.audioFileExt},
                {name: "vo_queen_58", url: "audio/mono/vos/queen/vo_queen_58" + P3.assets.audioFileExt},
                {name: "vo_queen_61b", url: "audio/mono/vos/queen/vo_queen_61b" + P3.assets.audioFileExt},
                {name: "vo_queen_126", url: "audio/mono/vos/queen/vo_queen_126" + P3.assets.audioFileExt},
                {name: "vo_queen_127b", url: "audio/mono/vos/queen/vo_queen_127b" + P3.assets.audioFileExt},
                {name: "vo_queen_128", url: "audio/mono/vos/queen/vo_queen_128" + P3.assets.audioFileExt},
                {name: "vo_queen_129", url: "audio/mono/vos/queen/vo_queen_129" + P3.assets.audioFileExt},
                {name: "vo_queen_130", url: "audio/mono/vos/queen/vo_queen_130" + P3.assets.audioFileExt},

                {name: "vo_queen_131", url: "audio/mono/vos/queen/vo_queen_131" + P3.assets.audioFileExt},
                {name: "vo_queen_132", url: "audio/mono/vos/queen/vo_queen_132" + P3.assets.audioFileExt},
                {name: "vo_queen_133b", url: "audio/mono/vos/queen/vo_queen_133b" + P3.assets.audioFileExt},
                {name: "vo_queen_134b", url: "audio/mono/vos/queen/vo_queen_134b" + P3.assets.audioFileExt},
                {name: "vo_queen_135", url: "audio/mono/vos/queen/vo_queen_135" + P3.assets.audioFileExt},
                {name: "vo_queen_136f", url: "audio/mono/vos/queen/vo_queen_136f" + P3.assets.audioFileExt},
                {name: "vo_queen_137", url: "audio/mono/vos/queen/vo_queen_137" + P3.assets.audioFileExt},

                {name: "vo_queen_104a", url: "audio/mono/vos/queen/vo_queen_104a" + P3.assets.audioFileExt},
                {name: "vo_queen_112a", url: "audio/mono/vos/queen/vo_queen_112a" + P3.assets.audioFileExt},
                {name: "vo_queen_114c", url: "audio/mono/vos/queen/vo_queen_114c" + P3.assets.audioFileExt},
                {name: "vo_queen_115", url: "audio/mono/vos/queen/vo_queen_115" + P3.assets.audioFileExt},
                {name: "vo_queen_116", url: "audio/mono/vos/queen/vo_queen_116" + P3.assets.audioFileExt},
                {name: "vo_queen_118", url: "audio/mono/vos/queen/vo_queen_118" + P3.assets.audioFileExt},
                {name: "vo_queen_119b", url: "audio/mono/vos/queen/vo_queen_119b" + P3.assets.audioFileExt},
                {name: "vo_queen_120a", url: "audio/mono/vos/queen/vo_queen_120a" + P3.assets.audioFileExt},
                {name: "vo_queen_123", url: "audio/mono/vos/queen/vo_queen_123" + P3.assets.audioFileExt},

                {name: "vo_queen_62a", url: "audio/mono/vos/queen/vo_queen_62a" + P3.assets.audioFileExt},
                {name: "vo_queen_64", url: "audio/mono/vos/queen/vo_queen_64" + P3.assets.audioFileExt},
                {name: "vo_queen_68", url: "audio/mono/vos/queen/vo_queen_68" + P3.assets.audioFileExt},
                {name: "vo_queen_69", url: "audio/mono/vos/queen/vo_queen_69" + P3.assets.audioFileExt},
                {name: "vo_queen_70a", url: "audio/mono/vos/queen/vo_queen_70a" + P3.assets.audioFileExt},
                {name: "vo_queen_71a", url: "audio/mono/vos/queen/vo_queen_71a" + P3.assets.audioFileExt},
                {name: "vo_queen_72a", url: "audio/mono/vos/queen/vo_queen_72a" + P3.assets.audioFileExt},

                {name: "vo_queen_191b", url: "audio/mono/vos/queen/vo_queen_191b" + P3.assets.audioFileExt},
                {name: "vo_queen_193a", url: "audio/mono/vos/queen/vo_queen_193a" + P3.assets.audioFileExt},
                {name: "vo_queen_194b", url: "audio/mono/vos/queen/vo_queen_194b" + P3.assets.audioFileExt},
                {name: "vo_queen_195b", url: "audio/mono/vos/queen/vo_queen_195b" + P3.assets.audioFileExt},
                {name: "vo_queen_196c", url: "audio/mono/vos/queen/vo_queen_196c" + P3.assets.audioFileExt},
                {name: "vo_queen_200a", url: "audio/mono/vos/queen/vo_queen_200a" + P3.assets.audioFileExt},
                {name: "vo_queen_200b193a", url: "audio/mono/vos/queen/vo_queen_200b193a" + P3.assets.audioFileExt},
                {name: "vo_queen_200b194b", url: "audio/mono/vos/queen/vo_queen_200b194b" + P3.assets.audioFileExt},
                {name: "vo_queen_200b195b", url: "audio/mono/vos/queen/vo_queen_200b195b" + P3.assets.audioFileExt},
                {name: "vo_queen_200b196c", url: "audio/mono/vos/queen/vo_queen_200b196c" + P3.assets.audioFileExt},

                {name: "vo_guardian_neg_1", url: "audio/mono/vos/guardian/vo_guardian_neg_1" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_2", url: "audio/mono/vos/guardian/vo_guardian_neg_2" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_3", url: "audio/mono/vos/guardian/vo_guardian_neg_3" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_4", url: "audio/mono/vos/guardian/vo_guardian_neg_4" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_5", url: "audio/mono/vos/guardian/vo_guardian_neg_5" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_6", url: "audio/mono/vos/guardian/vo_guardian_neg_6" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_7", url: "audio/mono/vos/guardian/vo_guardian_neg_7" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_8", url: "audio/mono/vos/guardian/vo_guardian_neg_8" + P3.assets.audioFileExt},
                {name: "vo_guardian_neg_9", url: "audio/mono/vos/guardian/vo_guardian_neg_9" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_1", url: "audio/mono/vos/guardian/vo_guardian_pos_1" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_2", url: "audio/mono/vos/guardian/vo_guardian_pos_2" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_3", url: "audio/mono/vos/guardian/vo_guardian_pos_3" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_4", url: "audio/mono/vos/guardian/vo_guardian_pos_4" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_5", url: "audio/mono/vos/guardian/vo_guardian_pos_5" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_6", url: "audio/mono/vos/guardian/vo_guardian_pos_6" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_7", url: "audio/mono/vos/guardian/vo_guardian_pos_7" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_8", url: "audio/mono/vos/guardian/vo_guardian_pos_8" + P3.assets.audioFileExt},
                {name: "vo_guardian_pos_9", url: "audio/mono/vos/guardian/vo_guardian_pos_9" + P3.assets.audioFileExt},

                // music
                {name: "music_avatar_loop_00", url: "audio/mono/music/music_avatar_loop_00" + P3.assets.audioFileExt},
                {name: "music_battle_loop_01", url: "audio/mono/music/music_battle_loop_01" + P3.assets.audioFileExt},
                {name: "music_battle_loop_02", url: "audio/mono/music/music_battle_loop_02" + P3.assets.audioFileExt},
                {name: "music_battle_loop_03", url: "audio/mono/music/music_battle_loop_03" + P3.assets.audioFileExt},
                {name: "music_timed_battle_01", url: "audio/mono/music/music_timed_battle_01" + P3.assets.audioFileExt},
                {name: "music_timed_battle_02", url: "audio/mono/music/music_timed_battle_02" + P3.assets.audioFileExt},
                {name: "music_timed_battle_03", url: "audio/mono/music/music_timed_battle_03" + P3.assets.audioFileExt},
                {name: "music_pause_menu", url: "audio/mono/music/music_pause_menu" + P3.assets.audioFileExt},
                {name: "music_results_loop", url: "audio/mono/music/music_results_loop" + P3.assets.audioFileExt},
                {name: "music_round_lost", url: "audio/mono/music/music_round_lost" + P3.assets.audioFileExt},
                {name: "music_round_won", url: "audio/mono/music/music_round_won" + P3.assets.audioFileExt},

                // sfx
                {name: "sfx_scroll_disappear_00", url: "audio/mono/sfx_scroll_disappear_00" + P3.assets.audioFileExt},
                {name: "sfx_scroll_open_00", url: "audio/mono/sfx_scroll_open_00" + P3.assets.audioFileExt},
                {name: "sfx_scroll_open_01", url: "audio/mono/sfx_scroll_open_01" + P3.assets.audioFileExt},
                {name: "sfx_round_lost_00", url: "audio/mono/sfx_round_lost_00" + P3.assets.audioFileExt},
                {name: "sfx_round_won_00", url: "audio/mono/sfx_round_won_00" + P3.assets.audioFileExt},
                {name: "sfx_level_select_card_00", url: "audio/mono/sfx_level_select_card_00" + P3.assets.audioFileExt},
                {name: "sfx_loot_crate_reveal_02", url: "audio/mono/sfx_loot_crate_reveal_02" + P3.assets.audioFileExt},
                {name: "sfx_loot_crate_reveal_03", url: "audio/mono/sfx_loot_crate_reveal_03" + P3.assets.audioFileExt},
                {name: "sfx_lootcrate_open_00", url: "audio/mono/sfx_lootcrate_open_00" + P3.assets.audioFileExt},
                {name: "sfx_customise_close_00", url: "audio/mono/sfx_customise_close_00" + P3.assets.audioFileExt},
                {name: "sfx_customise_open_00", url: "audio/mono/sfx_customise_open_00" + P3.assets.audioFileExt},
                {name: "sfx_btn_keypad_press_00", url: "audio/mono/sfx_btn_keypad_press_00" + P3.assets.audioFileExt},
                {name: "sfx_btn_keypad_rollover_00", url: "audio/mono/sfx_btn_keypad_rollover_00" + P3.assets.audioFileExt},
                {name: "sfx_avatar_loop_ambience_01", url: "audio/mono/sfx_avatar_loop_ambience_01" + P3.assets.audioFileExt},
                {name: "sfx_block_move_00", url: "audio/mono/sfx_block_move_00" + P3.assets.audioFileExt},
                {name: "sfx_block_placed_01", url: "audio/mono/sfx_block_placed_01" + P3.assets.audioFileExt},

                {name: "sfx_guardian_arrow_attack_00", url: "audio/mono/sfx_guardian_arrow_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_hammer_attack_00", url: "audio/mono/sfx_guardian_hammer_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_magic_attack_00", url: "audio/mono/sfx_guardian_magic_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_spear_attack_00", url: "audio/mono/sfx_guardian_spear_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_spell_attack_00", url: "audio/mono/sfx_guardian_spell_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_guardian_sword_attack_00", url: "audio/mono/sfx_guardian_sword_attack_00" + P3.assets.audioFileExt},

                {name: "sfx_shield_level_1", url: "audio/mono/sfx_shield_level_1" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_2", url: "audio/mono/sfx_shield_level_2" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_3", url: "audio/mono/sfx_shield_level_3" + P3.assets.audioFileExt},
                {name: "sfx_shield_level_4", url: "audio/mono/sfx_shield_level_4" + P3.assets.audioFileExt},

                {name: "sfx_enter_dragon", url: "audio/mono/sfx_enter_dragon" + P3.assets.audioFileExt},
                {name: "sfx_enter_hobgoblin", url: "audio/mono/sfx_enter_hobgoblin" + P3.assets.audioFileExt},
                {name: "sfx_enter_mage", url: "audio/mono/sfx_enter_mage" + P3.assets.audioFileExt},
                {name: "sfx_enter_spider", url: "audio/mono/sfx_enter_spider" + P3.assets.audioFileExt},
                {name: "sfx_enter_spirit", url: "audio/mono/sfx_enter_spirit" + P3.assets.audioFileExt},
                {name: "sfx_enter_troll", url: "audio/mono/sfx_enter_troll" + P3.assets.audioFileExt},

                {name: "sfx_dragon_attack_00", url: "audio/mono/sfx_dragon_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_hobgoblin_attack_00", url: "audio/mono/sfx_hobgoblin_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_mage_attack_00", url: "audio/mono/sfx_mage_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_spider_attack_00", url: "audio/mono/sfx_spider_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_spirit_attack_00", url: "audio/mono/sfx_spirit_attack_00" + P3.assets.audioFileExt},
                {name: "sfx_troll_attack_00", url: "audio/mono/sfx_troll_attack_00" + P3.assets.audioFileExt},

                {name: "sfx_generic_adversary_damage_00", url: "audio/mono/sfx_generic_adversary_damage_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_adversary_damage_01", url: "audio/mono/sfx_generic_adversary_damage_01" + P3.assets.audioFileExt},
                {name: "sfx_generic_adversary_damage_02", url: "audio/mono/sfx_generic_adversary_damage_02" + P3.assets.audioFileExt},

                {name: "sfx_generic_guardian_damage_female_00", url: "audio/mono/sfx_generic_guardian_damage_female_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_female_01", url: "audio/mono/sfx_generic_guardian_damage_female_01" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_female_02", url: "audio/mono/sfx_generic_guardian_damage_female_02" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_male_00", url: "audio/mono/sfx_generic_guardian_damage_male_00" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_male_01", url: "audio/mono/sfx_generic_guardian_damage_male_01" + P3.assets.audioFileExt},
                {name: "sfx_generic_guardian_damage_male_02", url: "audio/mono/sfx_generic_guardian_damage_male_02" + P3.assets.audioFileExt},

                {name: "sfx_question_timer_01", url: "audio/mono/sfx_question_timer_01" + P3.assets.audioFileExt},
                {name: "sfx_ambience_crowd_roar_loop_00", url: "audio/mono/sfx_ambience_crowd_roar_loop_00" + P3.assets.audioFileExt},

                {name: "vo_queen_extra_01a", url: "audio/mono/vos/queen/vo_queen_extra_01a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_02a", url: "audio/mono/vos/queen/vo_queen_extra_02a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_03b", url: "audio/mono/vos/queen/vo_queen_extra_03b" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_04b", url: "audio/mono/vos/queen/vo_queen_extra_04b" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_15a", url: "audio/mono/vos/queen/vo_queen_extra_15a" + P3.assets.audioFileExt},

                {name: "vo_queen_extra_09b1", url: "audio/mono/vos/queen/vo_queen_extra_09b1" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_17b1", url: "audio/mono/vos/queen/vo_queen_extra_17b1" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_17b2", url: "audio/mono/vos/queen/vo_queen_extra_17b2" + P3.assets.audioFileExt},

                {name: "vo_queen_extra_18a", url: "audio/mono/vos/queen/vo_queen_extra_18a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_19a", url: "audio/mono/vos/queen/vo_queen_extra_19a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_20a", url: "audio/mono/vos/queen/vo_queen_extra_20a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_21a", url: "audio/mono/vos/queen/vo_queen_extra_21a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_22a", url: "audio/mono/vos/queen/vo_queen_extra_22a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_23a", url: "audio/mono/vos/queen/vo_queen_extra_23a" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_24a", url: "audio/mono/vos/queen/vo_queen_extra_24a" + P3.assets.audioFileExt},

                {name: "vo_queen_extra_11b12c", url: "audio/mono/vos/queen/vo_queen_extra_11b12c" + P3.assets.audioFileExt},
                {name: "vo_queen_extra_0608", url: "audio/mono/vos/queen/vo_queen_extra_0608" + P3.assets.audioFileExt}
            ]);
        }

        if (files.length)
        {
            const basePath = common.gmi ? common.gmi.gameDir : "./";
            P3.assets.addFiles(files, basePath + "assets/");
            P3.assets.signals.complete.once(() => this.onRequiredAssetsReady());

            P3.assets.load();
        }
    }

    loadSharedSpines() {
        const spines = [
            {
                name: "guardian_elf_male", sharedName: "guardian_elf", url: "spine/guardian_elf_male" + ".json",
                metadata: {}, textureSheets: [
                    "guardians_spine_elf_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_elf_female", sharedName: "guardian_elf", url: "spine/guardian_elf_female" + ".json",
                metadata: {}, textureSheets: [
                    "guardians_spine_elf_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_knight_male", sharedName: "guardian_knight", url: "spine/guardian_knight_male" + ".json",
                metadata: {},
                textureSheets: [
                    "guardians_spine_knight_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_knight_female", sharedName: "guardian_knight", url: "spine/guardian_knight_female" + ".json",
                metadata: {},
                textureSheets: [
                    "guardians_spine_knight_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_ranger_male", sharedName: "guardian_ranger", url: "spine/guardian_ranger_male" + ".json",
                metadata: {},
                textureSheets: [
                    "guardians_spine_ranger_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_ranger_female", sharedName: "guardian_ranger", url: "spine/guardian_ranger_female" + ".json",
                metadata: {},
                textureSheets: [
                    "guardians_spine_ranger_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_warrior", sharedName: "guardian_warrior", url: "spine/guardian_warrior" + ".json",
                metadata: {}, textureSheets: [
                    "guardians_spine_warrior_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_witch", sharedName: "guardian_witch", url: "spine/guardian_witch" + ".json",
                metadata: {}, textureSheets: [
                    "guardians_spine_witch_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_wizard", sharedName: "guardian_wizard", url: "spine/guardian_wizard" + ".json",
                metadata: {}, textureSheets: [
                    "guardians_spine_wizard_all",
                    "guardians_spine_equip",
                    "guardians_spine_vfx"
                ]
            },
            {
                name: "guardian_pet", sharedName: "guardian_pet", url: "spine/guardian_pet" + ".json",
                metadata: {}, textureSheets: ["guardians_spine_pets"]
            }
        ];
        const sharedAtlases = {};

        for (let i = 0; i < spines.length; ++i) {
            const t = spines[i];

            let atlas = sharedAtlases[t.sharedName];
            if (!atlas) {
                sharedAtlases[t.sharedName] = atlas = new PIXI.spine.core.TextureAtlas();

                const textures = {};
                for (let j = 0; j < t.textureSheets.length; ++j) {
                    const frames = P3.assets.json(t.textureSheets[j]).frames;
                    for (const k in frames) {
                        if (frames.hasOwnProperty(k)) {
                            const name = k.split(".")[0];
                            textures[name] = P3.assets.texture(name);
                        }
                    }
                }
                atlas.addTextureHash(textures, true);
            }
            t.metadata.spineAtlas = atlas;
        }

        const basePath = common.gmi ? common.gmi.gameDir : "./";
        P3.assets.addFiles(spines, basePath + "assets/");
        P3.assets.signals.complete.once(() =>
        {
            if (this._startReady)
            {
                this.start();
            }

            this._startReady = true;
        });
        P3.assets.load();
    }

    start() {
        this.loadRequiredAssets();

        common.gmi.gameLoaded();

        this._app = new Application();
        this._app.init();

        // tracking
        common.gmi.sendStatsEvent("gameloaded", true);
    }

    onRequiredAssetsReady()
    {
        common.requiredAssetsReady = true;
    }

    onCanvasResize(correct) {
        const settings = common.gmi.getAllSettings();

        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }

            P3.audio.mute(!settings.audio);
            P3.audio.mute(typeof settings.gameData !== "undefined" ? !settings.gameData.button_audio : false, "button");
        }
        else
        {
            P3.audio.mute(true);
            P3.audio.mute(true, "button");
        }
    }

    applyViewPatch()
    {
        P3.View.prototype.resize = function(first)
        {
            const resize = () =>
            {
                this._isResizing = false;

                if (PIXI.utils.isMobile.apple.any)
                {
                    setTimeout(() =>
                    {
                        this._holder.style.display = "block";

                        // this scroll is used in IOS 8.0+ to move the game down when the user clicks to show the scrollbar.
                        window.scrollTo(0, 0);
                    }, 100);
                }
                else
                {
                    this._holder.style.display = "block";
                }

                const width = PIXI.utils.isMobile.any ? document.documentElement.clientWidth : window.innerWidth;
                const height = PIXI.utils.isMobile.any ? document.documentElement.clientHeight : window.innerHeight;

                let adjustedHeight = height;

                if (this._options.aspectRatioFillHeight) {
                    let ratioW = width / this._options.width;
                    let ratioH = this._options.height / height;

                    this._updateDimensions(
                        Math.floor((this._options.width * ratioW) * ratioH),
                        this._options.height
                    );
                } else {
                    let ratioW = this._options.width / width;
                    let ratioH = height / this._options.height;

                    this._updateDimensions(
                        this._options.width,
                        Math.floor((this._options.height * ratioH) * ratioW)
                    );
                }

                if (this.isCorrectOrientation && window.screen.height === 568)
                {
                    if (window.self === window.top)
                    {
                        adjustedHeight = height - 32;
                        this._holder.style.width = width + "px";
                        this._holder.style.height = adjustedHeight + "px";
                    }
                    else
                    {
                        this._holder.style.width = "100%";
                        this._holder.style.height = "99%";
                    }
                }
                else
                {
                    if (window.self === window.top)
                    {
                        this._holder.style.width = width + "px";
                        this._holder.style.height = height + "px";
                    }
                    else
                    {
                        this._holder.style.width = "100%";
                        this._holder.style.height = "100%";
                    }
                }

                if (PIXI.utils.isMobile.apple.device)
                {
                    this._iosfix.style.height = parseInt(height) + 1 + "px";
                }

                // this scroll is used in IOS 8.0+ to move the game down when the user clicks to show the scrollbar.
                //window.scrollTo(0, 0);

                if (this._options.aspectRatioFillHeight) {
                    let ratioW = width / this._options.width;
                    let ratioH = this._options.height / adjustedHeight;

                    this._updateDimensions(
                        Math.floor((this._options.width * ratioW) * ratioH),
                        this._options.height
                    );
                } else {
                    let ratioW = this._options.width / width;
                    let ratioH = adjustedHeight / this._options.height;

                    this._updateDimensions(
                        this._options.width,
                        Math.floor((this._options.height * ratioH) * ratioW)
                    );
                }

                this.toggleRotate(!this.isCorrectOrientation);
                !first && this.signals.resize.dispatch(this.isCorrectOrientation);
            }

            if (!this._isResizing)
            {
                this._isResizing = true;

                this._holder.style.display = "none";

                if (PIXI.utils.isMobile.any)
                {
                    if (first)
                    {
                        resize();
                    }
                    else
                    {
                        setTimeout(() => { resize(); }, PIXI.utils.isMobile.android.any ? 1000 : 400);
                    }
                }
                else
                {
                    resize();
                }
            }
        }
    }
}
